import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import { useAuthContext } from 'src/auth/hooks';
import Iconify from 'src/components/iconify/index';

// ----------------------------------------------------------------------
const iconCustom = (name) => (
  <Iconify icon={name} />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

// ----------------------------------------------------------------------

export function useNavData() {
  const { user: dataUser } = useAuthContext();
  let dataFilteredWithPermission = [];
  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: 'Administracion',
        items: [
          {
            title: 'Productos',
            path: paths.dashboard.products.list, icon:
              iconCustom("fluent-mdl2:product-variant"),
            componente: 'Productos',
            children: [
              { title: 'Productos', path: paths.dashboard.products.list, icon: iconCustom("fluent-mdl2:product-variant"), componente: 'Productos' },
              { title: 'Categorias', path: paths.dashboard.categories.list, icon: iconCustom("tabler:category"), componente: 'Categorias', },
              { title: 'Atributos', path: paths.dashboard.attributes.list, icon: iconCustom("mdi:dots-triangle"), componente: 'Atributos', },

            ]
          },
          { title: 'Clientes', path: paths.dashboard.clients.list, icon: iconCustom("stash:people-group-duotone"), componente: 'Clientes', },
          { title: 'Compras',
            path: paths.dashboard.compras.list,
            icon: iconCustom("solar:cart-large-2-bold"),
            componente: 'Compras',
            children: [
              { title: 'Compras', path: paths.dashboard.compras.list, icon: iconCustom("solar:cart-large-2-bold"), componente: 'Compras' },
              { title: 'Proveedores', path: paths.dashboard.proveedores.list, icon: iconCustom("mdi:truck-delivery"), componente: 'Proveedores' },
            ]
          },
          { title: 'Configuracion FEL', path: paths.dashboard.settingFel.list, icon: iconCustom("tdesign:file-setting"), componente: 'ConfiguracionFel', },
          { title: 'Impresoras', path: paths.dashboard.printers.list, icon: iconCustom("mdi:printer"), componente: 'Impresoras', },
          { title: 'Fel', path: paths.dashboard.fel.list, icon: iconCustom("mdi:invoice-list-outline"), componente: 'Fel', },
          {
            title: 'Care',
            path: paths.dashboard.care.pacientes.list,
            icon: iconCustom("mdi:medical-bag"),
            componente: 'Pacientes',
            children: [
              { title: 'Pacientes', path: paths.dashboard.care.pacientes.list, icon: iconCustom("mdi:medical-bag"), componente: 'Pacientes' },
              { title: 'Citas', path: paths.dashboard.care.citas.list, icon: iconCustom("mdi:clipboard-text-date"), componente: 'Citas' },
              { title: 'Tipo Citas', path: paths.dashboard.care.tipoCitas.list, icon: iconCustom("mdi:calendar-range"), componente: 'TipoCitas' }
            ]
          },
          {
            title: 'Autogestión',
            path: paths.dashboard.autogestion.mesas.list,
            icon: iconCustom("carbon:user-certification"),
            componente: 'Autogestion',
            children: [
              { title: 'Mesas Autoservicio', path: paths.dashboard.autogestion.mesas.list, icon: iconCustom("carbon:user-certification"), componente: 'MesasAutoservicio' }
            ]
          }
        ],
      },
      {
        subheader: 'Procesos',
        items: [
          { title: 'Historico', path: paths.dashboard.history.list, icon: iconCustom("icon-park-outline:history-query"), componente: 'Historico', },
          { title: 'Estadisticas ventas', path: paths.dashboard.dashboards.ventas, icon: iconCustom("material-symbols:monitoring"), componente: 'EstadisticasVentas', },
          { title: 'Comparativos', path: paths.dashboard.dashboards.comparativos, icon: iconCustom("uil:comparison"), componente: 'Comparativos', },
          {
            title: 'Reportes',
            path: paths.dashboard.reportes.ventas,
            icon: iconCustom("mdi:file-chart-outline"),
            componente: 'Reportes',
            children: [
              { title: 'Reporte de ventas', path: paths.dashboard.reportes.ventas, componente: 'ReporteVentas' },
              {
                title: 'Pronósticos',
                path: paths.dashboard.inventario.pronostico,
                componente: 'Pronosticos',
                children: [
                  { title: 'Pronóstico de ingredientes', path: paths.dashboard.inventario.pronostico, componente: 'IngredientesPorProducto' },
                  { title: 'Pronóstico de inventario', path: paths.dashboard.inventario.pronosticoProductos, componente: 'PronosticoInventario' },
                ]
              },
            ]
          },
          { title: 'Cocina', path: paths.dashboard.cocina.list, icon: iconCustom("game-icons:cook"), componente: 'Cocina', },
          { title: 'Cajas', path: paths.dashboard.cashbox.list, icon: iconCustom("ph:cash-register"), componente: 'Cajas', },
          { title: 'Cajeros', path: paths.dashboard.cashiers.list, icon: iconCustom("fluent:people-team-toolbox-24-filled"), componente: 'Cajeros', },
          { title: 'Traslados', path: paths.dashboard.traslados.list, icon: iconCustom("fluent:arrow-swap-20-filled"), componente: 'Traslados', },
        ],
      },
    ],
    []
  );

  if (dataUser) {
    const componentsAccessUser = dataUser?.rutas?.map(ruta => {
      let components = [];
      if (ruta.subMenu) {
        components = ruta.subMenu.map((component) => (component.componente.toLowerCase()))
      }
      else {
        components = ruta.componente.toLowerCase();
      }
      return components;
    }).flat();

    // Función recursiva para filtrar items con children
    const filterItemWithChildren = (item) => {
      // Si el item tiene children, filtrarlos recursivamente
      if (item.children && item.children.length > 0) {
        const filteredChildren = item.children
          .map(child => filterItemWithChildren(child))
          .filter(child => child !== null);

        // Si tiene children filtrados o el padre tiene permiso, incluirlo
        if (
          filteredChildren.length > 0 ||
          componentsAccessUser.includes(item.componente?.toLowerCase())
        ) {
          return {
            ...item,
            children: filteredChildren
          };
        }
        return null;
      }

      // Si no tiene children, verificar si tiene permiso (incluyendo compatibilidad entre autogestion y mesasautoservicio)
      const hasPermission =
        componentsAccessUser.includes(item.componente?.toLowerCase()) ||
        (item.componente?.toLowerCase() === 'mesasautoservicio' && componentsAccessUser.includes('autogestion'));

      if (hasPermission) {
        return item;
      }

      return null;
    };

    dataFilteredWithPermission = data.map((item) => {
      let itemsFiltered = [];
      if (item.items.length > 0) {
        itemsFiltered = item.items
          .map(servicio => filterItemWithChildren(servicio))
          .filter(servicio => servicio !== null);
      }
      return {
        items: itemsFiltered,
        subheader: item.subheader,
      }
    });

    dataFilteredWithPermission = dataFilteredWithPermission.filter((array) => (array.items.length > 0));

  }

  return dataFilteredWithPermission;
}
